import { useLocales as UseLocales } from '@/locales';
import {
  Building,
  Clock,
  LayoutGrid,
  ListOrdered,
  ScanText,
} from 'lucide-react';

const menuItems = () => {
  const { translate } = UseLocales();

  return [
    {
      menu: translate('Custom_clearance') || translate('All_applications'),
      label: 'all-applications',
      icon: <LayoutGrid />,
    },
    // {
    //   menu: translate('Application_under_consideration'),
    //   label: 'applications',
    //   icon: <Clock />,
    // },
    // {
    //   menu: translate('Accepted_applications'),
    //   label: 'accepted-applications',
    //   icon: <CheckCircle />,
    // },
    {
      menu: translate('Certicate_cargo'),
      label: 'certification',
      icon: <ScanText />,
    },
    {
      menu: translate('TN_VED_code'),
      label: 'code',
      icon: <Clock />,
    },
    {
      menu: translate('Adress_post'),
      label: 'post_office',
      icon: <Building />,
    },
    {
      menu: translate('directories'),
      label: 'wrapper',
      icon: <ListOrdered />,
      children: [
        {
          menu: 'Справочники',
          label: 'directory',
          // icon: <AllInclusiveOutlined />,
        },
        {
          menu: 'Калькулятор',
          label: 'calc',

          // icon: <AllInclusiveOutlined />,
        },
        {
          menu: translate('Classifier_of_customs_posts'),
          label: 'pcode',
          // icon: <Inventory2Sharp />,
        },
        {
          menu: translate('Account_information'),
          label: 'facture',
          // icon: <AccountBalance />,
        },
      ],
      // icon: <Clock />,
    },
  ];
};

export default menuItems;
